import { render, staticRenderFns } from "./wowKitBomConfiguration.vue?vue&type=template&id=0f109a71"
import script from "./wowKitBomConfiguration.vue?vue&type=script&lang=js"
export * from "./wowKitBomConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports